export enum KnmActionsEnum {
  KNM_CATALOGS_INIT = 'KNM_CATALOGS_INIT',
  KNM_CREATE = 'KNM_CREATE',
  KNM_RELOAD = 'KNM_RELOAD',
  KNM_HISTORY_RELOAD = 'KNM_HISTORY_RELOAD',
  KNM_RESET = 'KNM_RESET',
  KNM_SET_ACTIONS_DROPDOWN_VISIBLE = 'KNM_SET_ACTIONS_DROPDOWN_VISIBLE',
  KNM_SET_URL_ID = 'KNM_SET_URL_ID',
  KNM_SET_RAW_DATA = 'KNM_SET_RAW_DATA',
  KNM_PATCH_RAW_DATA = 'KNM_PATCH_RAW_DATA',
  KNM_GET = 'KNM_GET',
  KNM_GET_REQUEST = 'KNM_GET_REQUEST',
  KNM_GET_SUCCESS = 'KNM_GET_SUCCESS',
  KNM_GET_FAILURE = 'KNM_GET_FAILURE',
  KNM_UPDATE = 'KNM_UPDATE',
  KNM_UPDATE_REQUEST = 'KNM_UPDATE_REQUEST',
  KNM_UPDATE_SUCCESS = 'KNM_UPDATE_SUCCESS',
  KNM_UPDATE_FAILURE = 'KNM_UPDATE_FAILURE',
  KNM_DRAFT_SAVE = 'KNM_DRAFT_SAVE',
  KNM_DRAFT_DELETE = 'KNM_DRAFT_DELETE',
  KNM_COPY = 'KNM_COPY',
  KNM_COPY_REQUEST = 'KNM_COPY_REQUEST',
  KNM_COPY_SUCCESS = 'KNM_COPY_SUCCESS',
  KNM_COPY_FAILURE = 'KNM_COPY_FAILURE',
  KNM_DOWNLOAD_CURRENT_VERSION = 'KNM_DOWNLOAD_CURRENT_VERSION',
  KNM_EXCLUDE_FROM_PLAN = 'KNM_EXCLUDE_FROM_PLAN',
  KNM_EXCLUDE_FROM_PLAN_REQUEST = 'KNM_EXCLUDE_FROM_PLAN_REQUEST',
  KNM_EXCLUDE_FROM_PLAN_SUCCESS = 'KNM_EXCLUDE_FROM_PLAN_SUCCESS',
  KNM_EXCLUDE_FROM_PLAN_FAILURE = 'KNM_EXCLUDE_FROM_PLAN_FAILURE',
  KNM_INIT_EDITORS_UPDATE = 'KNM_INIT_EDITORS_UPDATE',
  KNM_SET_ERKNM_KNO_ORGANIZATION_FORM_VALUE = 'KNM_SET_ERKNM_KNO_ORGANIZATION_FORM_VALUE',
  KNM_SET_ERKNM_SUPERVISION_TYPE_FORM_VALUE = 'KNM_SET_ERKNM_SUPERVISION_TYPE_FORM_VALUE',
  KNM_SET_ERKNM_KNM_KIND_VERSION_ID_FORM_VALUE = 'KNM_SET_ERKNM_KNM_KIND_VERSION_ID_FORM_VALUE',
  KNM_SET_ERROR_FIELDS = 'KNM_SET_ERROR_FIELDS',
  KNM_SET_STATUS_HINT_TEXT = 'KNM_SET_STATUS_HINT_TEXT',
  KNM_SET_STATUS_HINT_FIELDS = 'KNM_SET_STATUS_HINT_FIELDS',
  KNM_SET_FORM_REF = 'KNM_SET_FORM_REF',
  KNM_SET_KNO_ORGANIZATION_FORM_VALUE = 'KNM_SET_KNO_ORGANIZATION_FORM_VALUE',
  KNM_SET_KNO_ORGANIZATION_ERVK_FORM_VALUE = 'KNM_SET_KNO_ORGANIZATION_ERVK_FORM_VALUE',
  KNM_SET_FEDERAL_LAW_FORM_VALUE = 'KNM_SET_FEDERAL_LAW_FORM_VALUE',
  KNM_SET_LEGAL_ENTITY_DATA = 'KNM_SET_LEGAL_ENTITY_DATA',
  KNM_SET_LOADING_FLAGS = 'KNM_SET_LOADING_FLAGS',
  KNM_SET_PATH = 'KNM_SET_PATH',
  KNM_SET_PUBLISHED_STATUS = 'KNM_SET_PUBLISHED_STATUS',
  KNM_SET_EDIT_STATUS = 'KNM_SET_EDIT_STATUS',
  KNM_SET_EDITOR_TIME = 'KNM_SET_EDITOR_TIME',
  KNM_SET_PREV_KNM_EDITORS = 'KNM_SET_PREV_KNM_EDITORS',
  KNM_SET_STATUS = 'KNM_SET_STATUS',
  KNM_SET_STATUS_TEXT = 'KNM_SET_STATUS_TEXT',
  KNM_SET_SUBJECT_TYPE_FORM_VALUE = 'KNM_SET_SUBJECT_TYPE_FORM_VALUE',
  KNM_SET_SUPERVISION_TYPE_FORM_VALUE = 'KNM_SET_SUPERVISION_TYPE_FORM_VALUE',
  KNM_SET_SUPERVISION_TYPE_ERVK_FORM_VALUE = 'KNM_SET_SUPERVISION_TYPE_ERVK_FORM_VALUE',
  KNM_SET_TYPE_FORM_VALUE = 'KNM_SET_TYPE_FORM_VALUE',
  KNM_SET_TYPE_ERVK_FORM_VALUE = 'KNM_SET_TYPE_ERVK_FORM_VALUE',
  KNM_SET_PM_SUPERVISION_TYPE = 'KNM_SET_PM_SUPERVISION_TYPE',
  KNM_SET_SYSTEM_TYPE = 'KNM_SET_SYSTEM_TYPE',
  KNM_SET_IS_CHANGE_PLAN_REASON_ACTIVE = 'KNM_SET_IS_CHANGE_PLAN_REASON_ACTIVE',
  KNM_EXPORT_KNM = 'KNM_EXPORT_KNM',
  KNM_SET_ON_SAVE_BUTTON_CLICK = 'KNM_SET_ON_SAVE_BUTTON_CLICK',
  KNM_SET_OPEN_REMOVE_FROM_PLAN_MODAL = 'KNM_SET_OPEN_REMOVE_FROM_PLAN_MODAL',
  KNM_SIGN = 'KNM_SIGN',
  KNM_SIGN_WITH_SAVE_SIGNER = 'KNM_SIGN_WITH_SAVE_SIGNER',
  KNM_TEST_SIGN = 'KNM_TEST_SIGN',
  KNM_TEST_SIGN_WITH_SAVE_SIGNER = 'KNM_TEST_SIGN_WITH_SAVE_SIGNER',
  KNM_SET_PUBLISH_KNM = 'KNM_SET_PUBLISH_KNM',
  KNM_SET_KNM_END_BY_ERKNM = 'KNM_SET_KNM_END_BY_ERKNM',
  KNM_SET_TRY_OPEN_SIGN_MODAL = 'KNM_SET_TRY_OPEN_SIGN_MODAL',
  KNM_SET_UNPUBLISH_KNM = 'KNM_SET_UNPUBLISH_KNM',
  KNM_SET_DOWNLOAD_PROSECUTOR_DOCS = 'KNM_SET_DOWNLOAD_PROSECUTOR_DOCS',
  KNM_PLAN_FIND_GET = 'KNM_PLAN_FIND_GET',
  KNM_PLAN_FIND_GET_REQUEST = 'KNM_PLAN_FIND_GET_REQUEST',
  KNM_PLAN_FIND_GET_SUCCESS = 'KNM_PLAN_FIND_GET_SUCCESS',
  KNM_PLAN_FIND_GET_FAILURE = 'KNM_PLAN_FIND_GET_FAILURE',
  KNM_PLAN_FIND_GET_END = 'KNM_PLAN_FIND_GET_END',
  KNM_PLAN_VALIDATE_UNSIGNED_KNM = 'KNM_PLAN_VALIDATE_UNSIGNED_KNM',
  KNM_PLAN_VALIDATE_UNSIGNED_KNM_CLEAR = 'KNM_PLAN_VALIDATE_UNSIGNED_KNM_CLEAR',
  KNM_PLAN_VALIDATE_UNSIGNED_KNM_REQUEST = 'KNM_PLAN_VALIDATE_UNSIGNED_KNM_REQUEST',
  KNM_PLAN_VALIDATE_UNSIGNED_KNM_SUCCESS = 'KNM_PLAN_VALIDATE_UNSIGNED_KNM_SUCCESS',
  KNM_PLAN_VALIDATE_UNSIGNED_KNM_FAILURE = 'KNM_PLAN_VALIDATE_UNSIGNED_KNM_FAILURE',
  KNM_SET_OPEN_CHANGE_KNM_MODAL = 'KNM_SET_OPEN_CHANGE_KNM_MODAL',
  KNM_VIOLATIONS_GET_REQUEST = 'KNM_VIOLATIONS_GET_REQUEST',
  KNM_VIOLATIONS_GET_SUCCESS = 'KNM_VIOLATIONS_GET_SUCCESS',
  KNM_VIOLATIONS_GET_FAILURE = 'KNM_VIOLATIONS_GET_FAILURE',
  KNM_CHECKLIST_TEMPLATES_GET = 'KNM_CHECKLIST_TEMPLATES_GET',
  KNM_REQUIREMENT_TEMPLATES_GET = 'KNM_REQUIREMENT_TEMPLATES_GET',
  KNM_KNO_ORGANIZATION_FUNCTIONS_GET = 'KNM_KNO_ORGANIZATION_FUNCTIONS_GET',
  KNM_ADD_VISIBLE_MODALS = 'KNM_ADD_VISIBLE_MODALS',
  KNM_REMOVE_VISIBLE_MODALS = 'KNM_REMOVE_VISIBLE_MODALS',
  KNM_ATTACH_WEB_DOCUMENT = 'KNM_ATTACH_WEB_DOCUMENT',
  KNM_CHANGE_STATUS = 'KNM_CHANGE_STATUS',
  KNM_EXPORT_SIMILARITIES_LIST = 'KNM_EXPORT_SIMILARITIES_LIST',
  KNM_GET_HISTORY_CHANGES = 'KNM_GET_HISTORY_CHANGES',
  KNM_SET_HISTORY_CHANGES = 'KNM_SET_HISTORY_CHANGES',
  KNM_GET_SIGNED_HISTORY_CHANGES = 'KNM_GET_SIGNED_HISTORY_CHANGES',
  KNM_SET_SIGNED_HISTORY_CHANGES = 'KNM_SET_SIGNED_HISTORY_CHANGES',
  KNM_SET_HISTORY_CHANGES_IS_LOADING = 'KNM_SET_HISTORY_CHANGES_IS_LOADING',
  KNM_SET_HISTORY_CHANGES_IS_ON = 'KNM_SET_HISTORY_CHANGES_IS_ON',
  KNM_TRY_OPEN_SIGN_MODAL = 'KNM_TRY_OPEN_SIGN_MODAL',
  KNM_TRY_GENERATE_DECISION = 'KNM_TRY_GENERATE_DECISION',
  KNM_DOWNLOAD_XML = 'KNM_DOWNLOAD_XML',
  KNM_AGREEMENT_TEMPLATE_DOWNLOAD = 'KNM_AGREEMENT_TEMPLATE_DOWNLOAD',
  KNM_DELETE_SIGN = 'KNM_DELETE_SIGN',
  KNM_DOWNLOAD_SIGNED_ZIP = 'KNM_DOWNLOAD_SIGNED_ZIP',
  KNM_RESTORE = 'KNM_RESTORE',
  KNM_DELETE = 'KNM_DELETE',
  KNM_COMPLETE336_SUCCESS = 'KNM_COMPLETE336_SUCCESS',
  KNM_SET_SUBJECT_DATA = 'KNM_SET_SUBJECT_DATA',
  KNM_SET_AVAILABILITY_OF_CHANGING_SUBJECT_TYPE = 'KNM_SET_AVAILABILITY_OF_CHANGING_SUBJECT_TYPE',
  KNM_MAKE_CHANGE_SUBJECT_TYPE_AVAILABLE = 'KNM_MAKE_CHANGE_SUBJECT_TYPE_AVAILABLE',
  KNM_HANDLE_UPLOAD_ERKNM_ATTACH_WEB_DOCUMENT = 'KNM_HANDLE_UPLOAD_ERKNM_ATTACH_WEB_DOCUMENT',
  KNM_CREATE_PLANNED_KNM = 'KNM_CREATE_PLANNED_KNM',
  KNM_SIGN_UPLOAD_MODAL_APPLY = 'KNM_SIGN_UPLOAD_MODAL_APPLY',
  KNM_SIGN_SUBMIT_FAIL = 'KNM_SIGN_SUBMIT_FAIL',
  /**
   * Action для запроса с сервера списка дат, недоступных для выбора
   * в календаре в форме ввода даты начала и окончания КНМ
   */
  KNM_INFO_GET_EXCLUDE_DATES = 'KNM_INFO_GET_EXCLUDE_DATES',
  /**
   * Action для передачи в форму списка дат, недоступных для выбора
   * в календаре в форме ввода даты начала и окончания КНМ,
   * полученных с сервера
   */
  KNM_INFO_SET_EXCLUDE_DATES = 'KNM_INFO_SET_EXCLUDE_DATES',
  KNM_INFO_GET_WORK_DAYS_COUNT_BEFORE_START = 'KNM_INFO_GET_WORK_DAYS_COUNT_BEFORE_START',
  KNM_INFO_SET_WORK_DAYS_COUNT_BEFORE_START = 'KNM_INFO_SET_WORK_DAYS_COUNT_BEFORE_START',
  KNM_GET_PLANNED_ACTIVITIES = 'KNM_GET_PLANNED_ACTIVITIES',
  KNM_SET_PLANNED_ACTIVITIES = 'KNM_SET_PLANNED_ACTIVITIES',
  KNM_GET_NKO_FOREIGN_AGENT_DATA_BY_OGRN = 'KNM_GET_NKO_FOREIGN_AGENT_DATA_BY_OGRN',
  KNM_SET_NKO_FOREIGN_AGENT_DATA_BY_OGRN = 'KNM_SET_NKO_FOREIGN_AGENT_DATA_BY_OGRN',
  KNM_GET_IS_ORG_IN_SONKO_REGISTRY = 'KNM_GET_IS_ORG_IN_SONKO_REGISTRY',
  KNM_SET_IS_ORG_IN_SONKO_REGISTRY = 'KNM_SET_IS_ORG_IN_SONKO_REGISTRY',
  KNM_UPDATE_ACCESS_PRIVILEGE = 'KNM_UPDATE_ACCESS_PRIVILEGE',
  KNM_SET_ACCESS_SETTINGS_FORM_REF = 'KNM_SET_ACCESS_SETTINGS_FORM_REF',
  KNM_SET_INITIAL_ACCESS_SETTINGS_FORM_VALUES = 'KNM_SET_INITIAL_ACCESS_SETTINGS_FORM_VALUES',
  KNM_SET_ACCESS_NOTICE_ERP_ID = 'KNM_SET_ACCESS_NOTICE_ERP_ID',
  KNM_SET_ACCESS_NOTICE_KNO_ORGANIZATION_NAME = 'KNM_SET_ACCESS_NOTICE_KNO_ORGANIZATION_NAME',
  KNM_SET_CREATED_JUDGMENT_COURT = 'KNM_SET_CREATED_JUDGMENT_COURT',
  KNM_GET_EPGU_NOTIFICATION_LIST = 'KNM_GET_EPGU_NOTIFICATION_LIST',
  KNM_ADD_EPGU_NOTIFICATION_LIST = 'KNM_ADD_EPGU_NOTIFICATION_LIST',
  KNM_SET_EPGU_NOTIFICATION_TOTAL_COUNT = 'KNM_SET_EPGU_NOTIFICATION_TOTAL_COUNT',
  KNM_SET_APPROVE_ADD_NOTIFICATION_FUNCTION = 'KNM_SET_APPROVE_ADD_NOTIFICATION_FUNCTION',
  KNM_GET_ERVK_OBJECTS_OF_CONTROL = 'KNM_GET_ERVK_OBJECTS_OF_CONTROL',
  KNM_ADD_ERVK_OBJECTS_OF_CONTROL = 'KNM_ADD_ERVK_OBJECTS_OF_CONTROL',
  /**
   * Action для получения NPA
   */
  KNM_PLAN_GET_NPA = 'KNM_PLAN_GET_NPA',
  KNM_PLAN_GET_NPA_SUCCESS = 'KNM_PLAN_GET_NPA_SUCCESS',
  /**
   * Action для получения характеров наказания
   */
  KNM_PLAN_GET_PUNISHMENT_NATURE = 'KNM_PLAN_GET_PUNISHMENT_NATURE',
  KNM_PLAN_GET_PUNISHMENT_NATURE_SUCCESS = 'KNM_PLAN_GET_PUNISHMENT_NATURE_SUCCESS',
  KNM_SET_ERKNM_REASONS_FORM_VALUE = 'KNM_SET_ERKNM_REASONS_FORM_VALUE',
  KNM_SET_ERP_REASONS_FORM_VALUE = 'KNM_SET_ERP_REASONS_FORM_VALUE',
  KNM_SET_ERP_REASONS_ERVK_FORM_VALUE = 'KNM_SET_ERP_REASONS_ERVK_FORM_VALUE',
  KNM_SET_ERP_KIND_ERVK_VERSION_ID_FORM_VALUE = 'KNM_SET_ERP_KIND_ERVK_VERSION_ID_FORM_VALUE',
  KNM_SET_ORDER_VERSION_ID = 'KNM_SET_ORDER_VERSION_ID',

  KNM_GET_ORDERS = 'KNM_GET_ORDERS',
  KNM_SET_ORDERS = 'KNM_SET_ORDERS',
  KNM_CLEAR_ERVK_OBJECTS_OF_CONTROL = 'KNM_CLEAR_ERVK_OBJECTS_OF_CONTROL',
  KNM_CHECK_CHANGES = 'KNM_CHECK_CHANGES',
  KNM_CHECK_CHANGES_REQUEST = 'KNM_CHECK_CHANGES_REQUEST',
  KNM_CHECK_CHANGES_SUCCESS = 'KNM_CHECK_CHANGES_SUCCESS',
  KNM_CHECK_CHANGES_FAILURE = 'KNM_CHECK_CHANGES_FAILURE',
  KNM_SET_CHANGE_PLAN_REASON_AFTER_CONFIRM = 'KNM_SET_CHANGE_PLAN_REASON_AFTER_CONFIRM',

  KNM_SET_IS_CAN_BE_SIGNED = 'KNM_SET_IS_CAN_BE_SIGNED',
  KNM_CHECK_KNO_SUPERVISION_LINKS = 'KNM_CHECK_KNO_SUPERVISION_LINKS',
  KNM_SET_CHECK_KNO_SUPERVISION_LINKS = 'KNM_SET_CHECK_KNO_SUPERVISION_LINKS',

  KNM_GET_INVALID_FIELDS = 'KNM_GET_INVALID_FIELDS',
  KNM_SET_INVALID_FIELDS = 'KNM_SET_INVALID_FIELDS',
  KNM_CLEAR_INVALID_FIELDS = 'KNM_CLEAR_INVALID_FIELDS',

  KNM_ERVK_PROSECUTOR_GET = 'KNM_ERVK_PROSECUTOR_GET',
  KNM_ERVK_PROSECUTOR_REQUEST = 'KNM_ERVK_PROSECUTOR_REQUEST',
  KNM_ERVK_PROSECUTOR_SUCCESS = 'KNM_ERVK_PROSECUTOR_SUCCESS',
  KNM_ERVK_PROSECUTOR_FAILURE = 'KNM_ERVK_PROSECUTOR_FAILURE',

  KNM_GET_KNO_COLLABORATING_ORGANISATIONS = 'KNM_GET_KNO_COLLABORATING_ORGANISATIONS',
  KNM_SET_KNO_COLLABORATING_ORGANISATIONS = 'KNM_SET_KNO_COLLABORATING_ORGANISATIONS',
  KNM_GET_KNO_COLLABORATING_ORGANISATIONS_NEXT_PAGE = 'KNM_GET_KNO_COLLABORATING_ORGANISATIONS_NEXT_PAGE',

  KNM_SET_IS_SHOW_APPROVE_REMARKS = 'KNM_SET_IS_SHOW_APPROVE_REMARKS',
  KNM_RESTORE_LATEST_SIGNED_VERSION = 'KNM_RESTORE_LATEST_SIGNED_VERSION',
  KNM_SET_LOADING = 'KNM_SET_LOADING',

  KNM_GET_LATE_CHANGES_FIELDS_REQUEST = 'KNM_GET_LATE_CHANGES_FIELDS_REQUEST',
  KNM_GET_LATE_CHANGES_FIELDS_SUCCESS = 'KNM_GET_LATE_CHANGES_FIELDS_SUCCESS',
  KNM_GET_LATE_CHANGES_FIELDS_FAILURE = 'KNM_GET_LATE_CHANGES_FIELDS_FAILURE',

  KNM_SET_LATE_CHANGES_FIELDS_LINKS = 'KNM_SET_LATE_CHANGES_FIELDS_LINKS',

  KNM_SET_PM_IS_UNABLE_TO_REFUSE_FORM_VALUE = 'KNM_SET_PM_IS_UNABLE_TO_REFUSE_FORM_VALUE',
  KNM_FILL_ORGANIZATIONS_AND_OBJECTS_BY_OTHER_PASSPORT = 'KNM_FILL_ORGANIZATIONS_AND_OBJECTS_BY_OTHER_PASSPORT',

  KNM_SET_IS_NEED_ACT_SAVE_OR_SIGN = 'KNM_SET_IS_NEED_ACT_SAVE_OR_SIGN',

  KNM_UPDATE_EVIDENCES_BY_DECISION_LINKS = 'KNM_UPDATE_EVIDENCES_BY_DECISION_LINKS',

  KNM_SEND_AGREEMENT = 'KNM_SEND_AGREEMENT',
  KNM_SET_PRESCRIBE_DATA = 'KNM_SET_PRESCRIBE_DATA',
  KNM_ERKNM_CANCEL_PRESCRIBE = 'KNM_ERKNM_CANCEL_PRESCRIBE',
  KNM_SET_PRESCRIBE_SIGNED = 'KNM_SET_PRESCRIBE_SIGNED',
  KNM_SET_EXTERNAL_PARAMS = 'KNM_SET_EXTERNAL_PARAMS',

  KNM_SET_IS_SAVE_ON_PROCESS = 'KNM_SET_IS_SAVE_ON_PROCESS',
}
